// import React from "react";
import "../css/journeypage.css";
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import eal from "../assets/BTSwami_About/early-life-1-1.jpg";
import sp from "../assets/BTSwami_About/prabhupada.jpg";
import lol from "../assets/BTSwami_About/gbnf-3.jpg";
import wl from "../assets/BTSwami_About/world-leader-3.jpg";
import eal2 from "../assets/BTSwami_About/early-life-2-1.jpg";
import initiate from "../assets/BTSwami_About/initiate.jpg";
import initiate2 from "../assets/BTSwami_About/initiate2.jpg";
import sanyas1 from "../assets/BTSwami_About/sanyas1.jpg";
import sanyas2 from "../assets/BTSwami_About/sanyas2.jpg";
import Books from "../components/Books";


import React, { useState, useEffect } from 'react';

const AboutBhaktiTirthaSwami = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const timelineEvents = [
    {
      year: "1950",
      title: "Birth and Childhood",
      description:
        "Born as John Edwin Favors on February 25, 1950, in Cleveland, Ohio. Raised by a devout Christian mother who instilled strong spiritual values and discipline.",
      image: eal2,
    },
    {
      year: "1960s",
      title: "Youthful Leadership & Education",
      description:
        "Demonstrated early leadership, became student body president and active in civil rights movements. Developed deep intellectual and moral convictions.",
      image: eal,
    },
    {
      year: "1972",
      title: "Graduation from Princeton",
      description:
        "Graduated with honors from Princeton University with a major in psychology and African American studies. Already recognized as a charismatic leader.",
      image: eal2,
    },
    {
      year: "1973",
      title: "Spiritual Transformation",
      description:
        "Met His Divine Grace A.C. Bhaktivedanta Swami Prabhupada and became his disciple. Initiated into the Gaudiya Vaishnava tradition as Ghanashyam Dasa.",
      image: initiate,
    },
    {
      year: "1970s–1980s",
      title: "Missionary Work in Eastern Europe and Africa",
      description:
        "Smuggled spiritual literature behind the Iron Curtain. Preached and established ISKCON temples in Nigeria, Ghana, and other African countries.",
      image: initiate2,
    },
    {
      year: "1983",
      title: "Sannyasa & GBC Role",
      description:
        "Accepted the renounced order of life (sannyasa) and became known as Bhakti Tirtha Swami. Appointed as an ISKCON Governing Body Commissioner.",
      image: sanyas1,
    },
    {
      year: "1990s",
      title: "Global Teaching and Writing",
      description:
        "Authored over 17 influential books, including the 'Spiritual Warrior' series. Counseled world leaders and offered guidance to seekers across the globe.",
      image: sanyas2,
    },
    {
      year: "2005",
      title: "Departure from This World",
      description:
        "Left this world on June 27, 2005, in Gita Nagari, surrounded by disciples and well-wishers, chanting the Holy Names. His legacy continues to inspire.",
      image: lol,
    },
  ]

  const biographySections = [
    {
      title: "Early Life & Education",
      content: "Born as John E. Favors in a pious, God-fearing family, Bhakti Tirtha Swami showed exceptional spiritual inclinations from childhood. As a young child evangelist, he appeared regularly on television, sharing his faith and inspiring others. During his youth, he became a prominent leader in Dr. Martin Luther King Jr.'s civil rights movement, demonstrating his commitment to social justice and equality. At Princeton University, he distinguished himself as president of the student council and chairman of the Third World Coalition. Although his main degree was in psychology, he received accolades in many fields including politics, African studies, and international law, showcasing his diverse intellectual capabilities.",
      image: eal
    },
    {
      title: "Spiritual Journey",
      content: "Bhakti Tirtha Swami's spiritual transformation began when he encountered his spiritual teacher, A.C. Bhaktivedanta Swami Prabhupada. This meeting would forever change the course of his life and mission. In choosing Bhaktivedanta Swami as his guru, he felt compelled to share the wisdom he learned in a relevant and practical manner with the world. His approach combined ancient spiritual principles with modern leadership and personal development. His books became reference texts in universities and leadership organizations worldwide, translated into multiple languages including English, German, French, Spanish, Portuguese, Macedonian, Croatian, Russian, Hebrew, Slovenian, Balinese, and Italian.",
      image: sp
    },
    {
      title: "Global Leadership",
      content: "A specialist in international relations and conflict resolution, Bhakti Tirtha Swami traveled extensively around the world as a spiritual consultant to high-ranking members of the United Nations, celebrities, and various chiefs, kings, and high court justices. In 1990, he was coronated as a high chief in Warri, Nigeria, in recognition of his outstanding work in Africa and the world. He met several times with President Nelson Mandela of South Africa to share visions and strategies for world peace. His work included encouraging self-sufficiency through the development of schools, clinics, farm projects, and cottage industries while conducting seminars on principle-centered leadership and spiritual development.",
      image: wl
    },
    {
      title: "Legacy of Love",
      content: "On August 5, 2004, Bhakti Tirtha Swami was diagnosed with melanoma cancer. Despite making every effort to treat his condition, he used this challenge as an opportunity to teach perhaps his most important lesson—how to die with dignity and spiritual awareness. During his illness, he gave numerous lectures on the topic of death and dying, and completed his book 'The Beggar IV: Die Before Dying,' dedicated to this profound subject. On June 27, 2005, he departed from this world, surrounded by loving friends, relatives, and students, leaving behind a legacy of wisdom, compassion, and spiritual guidance that continues to inspire people worldwide.",
      image: lol
    }
  ];

  const TimelineItem = ({ event, index }) => {
    const isEven = index % 2 === 0;
    
    return (
      <div className={`timeline-item ${isVisible ? 'animate-in' : ''}`} 
           style={{ animationDelay: `${index * 0.1}s` }}>
        <div className="timeline-year">{event.year}</div>
        <div className={`timeline-content ${isEven ? 'left' : 'right'}`}>
          <div className="timeline-image">
            <img src={event.image} alt={event.title} />
          </div>
          <div className="timeline-text">
            <h3>{event.title}</h3>
            <p>{event.description}</p>
          </div>
        </div>
      </div>
    );
  };

  const BiographySection = ({ section, index }) => {
    const isEven = index % 2 === 0;
    
    return (
      <div className={`biography-section ${isEven ? 'normal' : 'reverse'} ${isVisible ? 'animate-in' : ''}`}
           style={{ animationDelay: `${index * 0.2}s` }}>
        <div className="section-image">
          <img src={section.image} alt={section.title} />
        </div>
        <div className="section-content">
          <h3>{section.title}</h3>
          <p>{section.content}</p>
        </div>
      </div>
    );
  };

  return (
    <>
        <Navbar/>
        <PageHeader title="His Holiness Bhakti Tirtha Swami" path="/about-bhakti-tirtha-swami" name="B.T Swami" />
        <div className="about-container">

            <div className="container">

                <main className="main-content">
                    <section className="biography">
                    <h2>About Bhakti Tirtha Swami</h2>
                    
                    <div className="intro">
                        Bhakti Tirtha Swami's teachings continue to inspire countless souls through his books and the lives of those who take inspiration from his profound message of love, service, and spiritual transformation.
                    </div>

                    {biographySections.map((section, index) => (
                        <BiographySection key={index} section={section} index={index} />
                    ))}

                    <div className="quote">
                        "Treat every person with whom you come in contact with the same care as the person you love the most."
                    </div>
                    </section>

                    <section className="timeline-section">
                    <h2>Life Journey Timeline</h2>
                    
                    <div className="timeline">
                        {timelineEvents.map((event, index) => (
                        <TimelineItem key={index} event={event} index={index} />
                        ))}
                    </div>
                    </section>
                </main>
            </div>
            <Books/>
        </div>
        <Footer/>
        <BackToTop/>
    </>
  );
};

export default AboutBhaktiTirthaSwami;